import type { Role } from '@/entities/user';

export const customersAccessRoles = ['admin'] as const satisfies readonly Role[];
